import { render, staticRenderFns } from "./SelectRolePopup.vue?vue&type=template&id=5651bcee&scoped=true&"
import script from "./SelectRolePopup.vue?vue&type=script&lang=js&"
export * from "./SelectRolePopup.vue?vue&type=script&lang=js&"
import style0 from "./SelectRolePopup.vue?vue&type=style&index=0&id=5651bcee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651bcee",
  null
  
)

export default component.exports